<template>
  <div>
    <NavbarAlt />
    <h1 class="texto-caveat text-center text-4xl md:text-5xl text-primary pt-10">Privacy Policy</h1>
    <div class="text-center pt-1">
      Golden Race Foundation
      <br />Privacy Policy - v1.0 - 25/05/2020
    </div>
    <div class="pt-6 px-6 lg:px-0 max-w-4xl mx-auto texto-roboto color-gray-700">
      The protection of your privacy is a very serious concern to SOFTQUO HOLDING LTD therefore we want you to be able to visit our web pages without being concerned about security issues. The following Privacy Policy will provide you with an overview of how the SOFTQUO HOLDING LTD guarantees the protection of your privacy, the type of data being collected as well as its main purpose.
    </div>
    <img class="mx-auto pt-6" src="../assets/images/mancha_alt.svg" alt="Brush" />
    <h2 class="texto-caveat text-center text-2xl md:text-3xl text-primary pt-6">Contact details</h2>
    <div class="px-6 lg:px-0 pb-10 max-w-4xl mx-auto texto-roboto color-gray-700">
      <p>All the data provided by our customers could be managed through automated (or no automated) instruments and will be incorporated to our client’s file; according to new General Data Protection Regulation (GDPR) and national laws and regulations. You can find the contact data of the controller/responsible, processor, Data Protection Officer and public authorities below:</p>
      <p class="font-bold">CONTACT</p>
      <div><span class="font-bold">Responsible:</span> SOFTQUO HOLDING LTD</div>
      <div><span class="font-bold">E-Mail:</span> gdpr@golden-race.com</div>
      <div><span class="font-bold">Data protection officer:</span> MARINA ANTÚNEZ FERNÁNDEZ</div>
      <p>If you have any problem with the information or solutions provided, you can contact with Malta's Office of the Data Protection Commissioner</p>
      <p>
        Data Protection Commissioner: Mr Joseph Ebejer 2, Airways House<br/>
        High Street, Sliema SLM 1549<br/>
        Tel. +356 2328 7100<br/>
        Fax +356 2328 7198
      </p>

      <div>
        <span class="font-bold">E-Mail:</span> <a href="mailto:commissioner.dataprotection@gov.mt">commissioner.dataprotection@gov.mt</a>
      </div>
      <div>
        <span class="font-bold">Website:</span> <a href="http://www.dataprotection.gov.mt/" target="_blank">http://www.dataprotection.gov.mt/</a>
        For another Data Protection Commissioner you can enter the following link
        <a href="http://ec.europa.eu/justice/article-29/structure/data-protection-authorities/index_en.htm">http://ec.europa.eu/justice/article-29/structure/data-protection-authorities/index_en.htm</a>
      </div>
    </div>

    <img class="mx-auto pt-6" src="../assets/images/mancha_alt.svg" alt="Brush" />
    <h2
      class="texto-caveat text-center text-2xl md:text-3xl text-primary pt-6 uppercase"
    >Which are the uses of your data?</h2>
    <div class="px-6 lg:px-0 pb-10 max-w-4xl mx-auto texto-roboto color-gray-700">
      <div>The data provided by users are:</div>
      <p>SOFTQUO HOLDING LTD assures that the mentioned data only will be managed for informative purposes.</p>
      <p>If you want to withdraw the consent for these processes, we invite you to contact us to any company email in point 1</p>
    </div>

    <img class="mx-auto pt-6" src="../assets/images/mancha_alt.svg" alt="Brush" />
    <h2
      class="texto-caveat text-center text-2xl md:text-3xl text-primary pt-6 uppercase"
    >About sharing information</h2>
    <div class="px-6 lg:px-0 pb-10 max-w-4xl mx-auto texto-roboto color-gray-700">
      <p>You accept that SOFTQUO HOLDING LTD may share information with another group company, always for contractual purposes, or some external companies we usually work (for example service providers).</p>
      <p>However, we might share your information in the case that Public Authorities request it (legal obligations).</p>
      <p>In the case that there would be any data transmission to a country outside the EU, we assure our customers the compliance with formal and security requirements in order to adapt our activity to GDPR.</p>
    </div>

    <img class="mx-auto pt-6" src="../assets/images/mancha_alt.svg" alt="Brush" />
    <h2
      class="texto-caveat text-center text-2xl md:text-3xl text-primary pt-6 uppercase"
    >Third parties’ links</h2>
    <div class="px-6 lg:px-0 pb-10 max-w-4xl mx-auto texto-roboto color-gray-700">
      <p>As you can verify, in our website there are several links to external websites. This Privacy Policy is not suitable for them, so we are not responsible of their data processing. If you have any problem with their activity, we invite you to contact public authorities in point 2 (Data Protection Commissioner).</p>
    </div>

    <Footer />
  </div>
</template>

<script>
import NavbarAlt from "@/components/parts/NavbarAlt";
import Footer from "@/components/parts/FooterAlt";

export default {
  name: "Privacy",
  metaInfo: {
    title: 'Privacy Policy | Golden Race Foundation'
  },
  components: {
    NavbarAlt,
    Footer
  }
};
</script>

<style scoped>
p {
  padding-top: 1.5rem;
}
</style>
